import type { RouteObject } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

import { AuthStrategy } from '@/lib/auth/strategy'
import { StrategyGuard } from '@/components/auth/strategy-guard'

export const route: RouteObject = {
	path: 'frontegg',
	element: (
		<StrategyGuard expected={AuthStrategy.FRONTEGG}>
			<Outlet />
		</StrategyGuard>
	),
	children: [
		{
			path: 'sign-in',
			lazy: async () => {
				const { Page } = await import('@/pages/auth/frontegg/sign-in')
				return { Component: Page }
			},
		},
	],
}
